import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=fc78b4ce&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=fc78b4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc78b4ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc78b4ce')) {
      api.createRecord('fc78b4ce', component.options)
    } else {
      api.reload('fc78b4ce', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=fc78b4ce&scoped=true&", function () {
      api.rerender('fc78b4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zk0dtKT87VYg/JS/comp/DocBox.vue"
export default component.exports